export enum CountryCode {
  Sweden = 'se',
  Japan = 'jp',
  Serbia = 'rs',
  Canada = 'ca',
  USA = 'us',
  Default = 'xz',
  Ireland = 'ie',
  GreatBritain = 'gb',
  Germany = 'de',
  Austria = 'at',
  Italy = 'it',
  France = 'fr',
  Norway = 'no',
  Denmark = 'dk',
  Poland = 'pl',
  Netherlands = 'nl',
  Finland = 'fi',
  Spain = 'es',
  Russia = 'ru',
  Australia = 'au',
  Portugal = 'pt',
  SouthKorea = 'kr',
  Switzerland = 'ch',
  Belgium = 'be',
  Slovenia = 'si',
  Romania = 'ro',
  Croatia = 'hr',
  Slovakia = 'sk',
  CzechRepublic = 'cz',
  Hungary = 'hu',
  India = 'in',
}
